import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBackground = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18 4.16667V15.8333C18 16.75 17.25 17.5 16.3333 17.5H4.66667C3.75 17.5 3 16.75 3 15.8333V4.16667C3 3.25 3.75 2.5 4.66667 2.5H16.3333C17.25 2.5 18 3.25 18 4.16667ZM9.66667 13.7583L7.91667 11.65C7.74167 11.4417 7.425 11.45 7.26667 11.6667L5.19167 14.3333C4.975 14.6083 5.16667 15.0083 5.51667 15.0083H15.5083C15.85 15.0083 16.05 14.6167 15.8417 14.3417L12.9167 10.4417C12.75 10.2167 12.4167 10.2167 12.25 10.4333L9.66667 13.7583Z",
		fill: "currentColor"
	})
});
export default SvgBackground;
